export default __webpack_public_path__ + "static/media/small-logo.4e693af1.svg";